import apiClient from "./apiClient";

export const sendSupportMessage = async (message: string): Promise<void> => {
    try {
        await apiClient.post("/support/send-message", { message });
    } catch (error) {
        console.error("Failed to send message.", error);
        throw error;
    }
};
